<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <div v-else>
      <v-card class="card-body">
        <v-container>
          <h5>Anrede</h5>

          <v-text-field
            id="anredeInputDE"
            v-model="anredenObject.anrede_de"
            label="Deutsch"
          />
          <v-text-field
            id="anredeInputFR"
            v-model="anredenObject.anrede_fr"
            label="Französisch"
          />
          <v-text-field
            id="anredeInputIT"
            v-model="anredenObject.anrede_it"
            label="Italienisch"
          />
        </v-container>
      </v-card>

      <v-card class="card-body">
        <v-container>
          <h5>Briefanrede</h5>

          <v-text-field
            id="briefanredeInputDE"
            v-model="anredenObject.briefanrede_de"
            label="Deutsch"
          />
          <v-text-field
            id="briefanredeInputFR"
            v-model="anredenObject.briefanrede_fr"
            label="Französisch"
          />
          <v-text-field
            id="briefanredeInputIT"
            v-model="anredenObject.briefanrede_it"
            label="Italienisch"
          />
        </v-container>
      </v-card>

      <v-btn
        :disabled="
          !anredenObject.anrede_de ||
            !anredenObject.anrede_fr ||
            !anredenObject.anrede_fr ||
            !anredenObject.briefanrede_de ||
            !anredenObject.briefanrede_fr ||
            !anredenObject.briefanrede_it
        "
        class="btn-left"
        color="success"
        raised
        title="Erfassen Abbrechen"
        @click="updateAnrede"
      >
        <i class="fas fa-save mr-3" /> Speichern
      </v-btn>

      <v-btn
        color="#e72b37"
        raised
        style="color: white"
        title="Erfassen Abbrechen"
        @click="cancelCreate"
      >
        <i class="fas fa-ban mr-3" /> Abbrechen
      </v-btn>
    </div>
  </div>
</template>
<script>
import {
  GetFormOfAddressWithId,
  PutFormOfAddress,
} from "@/services/user.crm.service";

export default {
  data() {
    return {
      isLoading: false,
      anredenObject: {
        formOfAddressId: null,
        id_de: null,
        id_fr: null,
        id_it: null,
        anrede_de: "",
        anrede_fr: "",
        anrede_it: "",
        briefanrede_de: "",
        briefanrede_fr: "",
        briefanrede_it: "",
      },
      errorObject: null,
    };
  },
  created() {
    this.isLoading = true;
    if (this.$route.query.anrede) {
      this.getAnrede(this.$route.query.anrede);
    }
    // this.getFormOfAddress();
  },
  methods: {
    cancelCreate() {
      this.$router.push({
        path: "/anrede",
      });
    },
    getAnrede(anredeId) {
      GetFormOfAddressWithId(
        anredeId,
        (response) => {
          this.anredenObject.formOfAddressId = response.id;

          //Werte zu den Einnzelnen Sprachen von der Abfrage auslesen
          const formOfAddressContents_de =
            response.formOfAddressContents.filter(
              (content) => content.language === "de-CH",
            )[0];
          const formOfAddressContents_fr =
            response.formOfAddressContents.filter(
              (content) => content.language === "fr-CH",
            )[0];
          const formOfAddressContents_it =
            response.formOfAddressContents.filter(
              (content) => content.language === "it-CH",
            )[0];
          //Deutsche Werte zuteilen
          this.anredenObject.id_de = formOfAddressContents_de.id;
          this.anredenObject.anrede_de = formOfAddressContents_de.value;
          this.anredenObject.briefanrede_de =
            formOfAddressContents_de.letterFormOfAddress;
          //Französische Werte zuteilen
          this.anredenObject.id_fr = formOfAddressContents_fr.id;
          this.anredenObject.anrede_fr = formOfAddressContents_fr.value;
          this.anredenObject.briefanrede_fr =
            formOfAddressContents_fr.letterFormOfAddress;
          //Italienische Werte zuteilen
          this.anredenObject.id_it = formOfAddressContents_it.id;
          this.anredenObject.anrede_it = formOfAddressContents_it.value;
          this.anredenObject.briefanrede_it =
            formOfAddressContents_it.letterFormOfAddress;

          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    updateAnrede() {
      this.isLoading = true;
      const updatedAnredenObject = {
        id: this.anredenObject.formOfAddressId,
        code: this.anredenObject.anrede_de,
        contentSortingOrder: 0,
        order: 0,
        formOfAddressContents: [
          {
            id: this.anredenObject.id_de,
            formOfAddressId: this.anredenObject.formOfAddressId,
            value: this.anredenObject.anrede_de,
            letterFormOfAddress: this.anredenObject.briefanrede_de,
            language: "de-CH",
          },
          {
            id: this.anredenObject.id_fr,
            formOfAddressId: this.anredenObject.formOfAddressId,
            value: this.anredenObject.anrede_fr,
            letterFormOfAddress: this.anredenObject.briefanrede_fr,
            language: "fr-CH",
          },
          {
            id: this.anredenObject.id_it,
            formOfAddressId: this.anredenObject.formOfAddressId,
            value: this.anredenObject.anrede_it,
            letterFormOfAddress: this.anredenObject.briefanrede_it,
            language: "it-CH",
          },
        ],
      };

      PutFormOfAddress(
        this.anredenObject.formOfAddressId,
        updatedAnredenObject,
        () => {
          this.isLoading = false;

          this.$router.push({
            path: `/anrede`,
            quey: { source: this.$route.path },
          });
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
  },
};
</script>
<style scoped>
.card-body {
  margin-top: 20px;

  margin-bottom: 20px;

  margin-left: 20px;
  width: 600px !important;
}

.btn-left {
  margin-left: 20px;
}
</style>
